import './Container.css'

interface Props {
  children: JSX.Element | JSX.Element[]
  className?: string
}

export function Container(props: Props) {
  return (
    <div className={`Container ${props.className || ''}`}>{props.children}</div>
  )
}
